import { Controller, useForm } from 'react-hook-form'
import TextField from 'baby-ui/foundation/TextField'
import { Grid } from '@material-ui/core'
import Autocomplete from 'baby-ui/foundation/AutoComplete'
import LoadingButton from 'baby-ui/compounds/LoadingButton'
import { observer } from 'mobx-react-lite'
import MaskedPhoneNumberTextField from 'baby-ui/foundation/MaskedPhoneNumberTextField'
import { ThemeConstants } from '../../styles'
import useStyles from './styles'
import { useDMEStore } from '../../store'
import { PhysicianSearchParams } from '../../requests'
import FirstNameTextField from './FirstNameTextField/FirstNameTextField'
import { useStateOptions } from './useStateOptions'

interface FormValues extends Omit<PhysicianSearchParams, 'stateAbbr'> {
  stateName: string
}

export interface PhysicianFormProps {
  submitFunction: (data: any) => void
  isLoading: boolean
  buttonText: string
  strategy?: 'search' | 'create'
}

export default observer(
  ({
    submitFunction,
    isLoading,
    buttonText,
    strategy = 'search',
  }: PhysicianFormProps) => {
    const store = useDMEStore()
    const classes = useStyles()

    const formDefaultValues = {
      firstName: store.physician.searchInput?.firstName,
      lastName: store.physician.searchInput?.lastName,
      stateName:
        store.physician.searchInput?.stateName ||
        store.insurance.state ||
        undefined,
      city: store.physician.searchInput?.city,
    }

    const { handleSubmit, control } = useForm<FormValues>({
      defaultValues: formDefaultValues,
      mode: 'onChange',
    })
    const { stateNames } = useStateOptions()

    return (
      <form onSubmit={handleSubmit(submitFunction)}>
        <Grid container spacing={ThemeConstants.BASE_SPACING}>
          <Grid item xs={12}>
            <Controller
              fullWidth
              required
              as={FirstNameTextField}
              control={control}
              disabled={isLoading}
              label="Provider's First Name"
              name="firstName"
              rules={{ required: true }}
              type="text"
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              fullWidth
              required
              as={TextField}
              control={control}
              disabled={isLoading}
              label="Provider's Last Name"
              name="lastName"
              rules={{ required: true }}
              type="text"
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              fullWidth
              required
              as={TextField}
              control={control}
              disabled={isLoading}
              label="City"
              name="city"
              rules={{ required: true }}
              type="text"
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              required
              as={({ value, onChange }) => (
                <Autocomplete
                  disabled={isLoading}
                  label="State"
                  options={stateNames}
                  textFieldProps={{ required: true }}
                  value={value}
                  onChange={(_e, selected) => {
                    onChange(selected)
                  }}
                />
              )}
              control={control}
              name="stateName"
              rules={{ required: true }}
            />
          </Grid>

          {strategy === 'create' && (
            <Grid item xs={12}>
              <Controller
                fullWidth
                required
                as={MaskedPhoneNumberTextField}
                control={control}
                label="Phone Number"
                name="phoneNumber"
                rules={{ required: true }}
                type="tel"
              />
            </Grid>
          )}
        </Grid>

        <LoadingButton
          fullWidth
          className={classes.loadingButton}
          color="primary"
          loading={isLoading}
          type="submit"
          variant="contained"
        >
          {buttonText}
        </LoadingButton>
      </form>
    )
  }
)
